import { render, staticRenderFns } from "./SessaoPlenaria.vue?vue&type=template&id=417fdbb4&scoped=true"
import script from "./SessaoPlenaria.vue?vue&type=script&lang=js"
export * from "./SessaoPlenaria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417fdbb4",
  null
  
)

export default component.exports